export default __webpack_public_path__ + "fonts/k3k702zokiljc3wvjuplznqqynqkv_9plp7mupa0s4g-webfont.woff2";